import { useMutation, useQueryClient } from 'react-query';
import request from '../../../../../../helpers/request';
import { useSelector } from 'react-redux';
import { getQueryKeys } from '../../../../queries/queryKeys';
import { message } from 'antd';

const chnageRegistrationType = async ({ houseId, registrationType }) => {
  const res = await request.post(
    `/HousingStock/change_registration_type_house`,
    undefined,
    'Не удалось изменить тип регистрации',
    'Error',
    undefined,
    { houseId, registrationTypeId: registrationType.id }
  );
  return res;
};

const chnageTemplateRegistrationType = async ({ houseId, templateId }) => {
  const res = await request.post(
    `/HousingStock/change_template_access_type_house`,
    undefined,
    'Не удалось изменить шаблон',
    'Error',
    undefined,
    { houseId, templateId }
  );
  return res;
};

const useChangeRegistrationType = () => {
  const queryClient = useQueryClient();

  const currentCompany = useSelector(
    (state) => state.housingStockStore.currentCompany
  );

  const mutation = useMutation(chnageRegistrationType, {
    onSuccess: async (data, { houseId, registrationType, templateId }) => {
      if (data !== 'Error') {
        if (templateId || templateId === 0) {
          await chnageTemplateRegistrationType({ houseId, templateId });
        }
        message.success('Тип регистрации успешно изменен', 2)

        queryClient.setQueryData(
          getQueryKeys.housingStockHouses({ companyId: currentCompany?.id }),
          (oldData) =>
            oldData.map((oldHouse) =>
              oldHouse.houseId === houseId
                ? { ...oldHouse, registrationType }
                : oldHouse
            )
        );
      }
    },
  });

  return {
    changeAsync: mutation.mutateAsync,
    loading: mutation.isLoading,
  };
};

export { useChangeRegistrationType };
